<template>
    <div style="display: contents">
        <v-data-table v-if="pc.hasAnyOnAccount" :headers="getPcHeaders(true)" dense
                      :items="pc.calculatedFees"
                      item-key="permitCartItemId"
                      :hide-default-footer="true"
                      class="elevation-1"
                      mobile-breakpoint="0">
            <template v-slot:item.totalFee="{ item }">
                {{ item.totalFee | formatMoney }}
            </template>
            <template v-slot:item.onAccountId="{ item }">
                <v-select v-model="item.onAccountId" :items="item.onAccounts" v-if="item.canBeOnAccount"
                          item-text="text" item-value="id"
                          @change="recalculateFees" clearable dense stack-label outlined class="mr-4 mt-4" attach offset-y></v-select>
            </template>
        </v-data-table>
        <v-data-table v-if="!pc.hasAnyOnAccount" :headers="getPcHeaders(false)" dense
                      :items="pc.calculatedFees"
                      item-key="permitCartItemId"
                      :hide-default-footer="true"
                      class="elevation-1"
                      mobile-breakpoint="0">
            <template v-slot:item.totalFee="{ item }">
                {{ item.totalFee | formatMoney }}
            </template>
        </v-data-table>
        <div class="ml-4 mt-4">
            <wrs-label :label="totalFeeLabel" :value="pc.totalFee | formatMoney" />
            <wrs-label v-if="pc.hasOnAccount" :label="totalOnAccountFeeLabel" :value="pc.totalOnAccountFee | formatMoney" />
            <wrs-label v-if="pc.hasOnAccount" :label="totalOwingFeeLabel" :value="pc.totalOwingFee | formatMoney" />
        </div>
    </div>
</template>
<script>
  // WrsFee
    import WrsLabel from './WrsLabel.vue';
    export default {
        components: {
          'wrs-label': WrsLabel
        },
        props: {
            pc: {
                type: Object,
                default: function () {
                    return {
                        permitCartItemId: 0,
                        hasAnyOnAccount: false,
                        hasOnAccount: false,
                        totalOwingFee: 0,
                        totalFee: 0,
                        totalOnAccountFee: 0,
                        calculatedFees: [],
                    };
                },
            },
            totalFeeLabel: {
                type: String,
                default: "Total Fee"
            },
            totalOwingFeeLabel: {
                type: String,
                default: "Total Owing Fee"
            },
            totalOnAccountFeeLabel: {
                type: String,
                default: "Total On Account Fee"
            },
            itemColumnHeaderLabel: {
                type: String,
                default: "Item"
            },
            feeColumnHeaderLabel: {
                type: String,
                default: "Fee"
            },
            chargeColumnHeaderLabel: {
                type: String,
                default: "Fee"
            }
        },
        methods: {
            getPcHeaders(hasOnAccount) {
                if (hasOnAccount) {
                    return [
                        { text: this.itemColumnHeaderLabel, value: 'description', width: '200px' },
                        { text: this.feeColumnHeaderLabel, value: 'totalFee', width: '150px' },
                        { text: this.chargeColumnHeaderLabel, value: 'onAccountId', width: '300px' },
                    ];
                }
                else {
                    return [
                        { text: this.itemColumnHeaderLabel, value: 'description', width: '200px' },
                        { text: this.feeColumnHeaderLabel, value: 'totalFee', width: '150px' },
                    ];
                }
            },
            recalculateFees: function () {
                if (!this.pc) return;
                var i = 0;
                let totalFee = 0;
                let totalOnAccountFee = 0;
                let hasOnAccount = false;
                for (i = 0; i < this.pc.calculatedFees.length; i++) {
                    if (this.pc.calculatedFees[i].onAccountId == null) {
                        this.pc.calculatedFees[i].onAccountId = 0;
                    }
                    this.pc.calculatedFees[i].isOnAccount = (this.pc.calculatedFees[i].onAccountId > 0);
                }
                for (i = 0; i < this.pc.calculatedFees.length; i++) {
                    totalFee += this.pc.calculatedFees[i].totalFee;
                    if (this.pc.calculatedFees[i].isOnAccount) {
                        totalOnAccountFee += this.pc.calculatedFees[i].totalFee;
                        hasOnAccount = true;
                    }
                }
                this.pc.totalFee = totalFee;
                this.pc.totalOnAccountFee = totalOnAccountFee;
                this.pc.totalOwingFee = totalFee - totalOnAccountFee;
                this.pc.hasOnAccount = hasOnAccount;
            },
            emitChangeEvent: function () {
                this.$emit('change');
            }
        }
    }
</script>
